<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData"  ref="form" label-width="130px"
        v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="pointId" label="巡查点位">
              {{ formData.pointName || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="inspectDate" label="巡查日期">
              {{ formData.inspectDate || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="taskResult" label="巡查结果">

              <el-tag type="success" v-if="formData.taskResult == '1'">正常</el-tag>
              <el-tag type="warning" v-if="formData.taskResult == '2'">异常</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="createUserName" label="巡查人">
              {{ formData.createUserName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-form-item prop="resultList" label="检查项">

            <el-table size="mini" class="table-form" stripe border :data="formData.resultList">
              <el-table-column show-overflow-tooltip min-width="150" label="检查项" prop="itemName">

              </el-table-column>
              <el-table-column show-overflow-tooltip min-width="100" label="检查结果" prop="checkResult">
                <template v-slot="{ $index }">

                  <el-tag type="success" v-if="formData.resultList[$index].checkResult == '1'">正常</el-tag>
                  <el-tag type="warning" v-if="formData.resultList[$index].checkResult == '2'">异常</el-tag>
                </template>
              </el-table-column>

            </el-table>

          </el-form-item>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="remark" label="备注">
              {{ formData.remark || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap" v-if="$attachmentFiles(formData.fileList).length>0">
                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>
              </div>
              <div style="color:#999" v-else>暂无</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'inspectionRecordDetail',
  data () {
    return {
      formData: {
        pointId: '',
        inspectDate: '',
        taskResult: '',
        remark: '',
        fileList: [],
        resultList: []
      },

      loading: false

    }
  },
  created () {
    if (this.taskId) {
      this.loadData()
    }
  },
  computed: {
    taskId () {
      return this.$route.query.taskId
    },
    pointType () {
      return this.$route.query.pointType
    },
    fileImgUrl() {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.inspectionRecord.selectPaInspectTaskByTaskId, {
          params: { taskId: this.taskId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          res.resultList = res.resultList ? res.resultList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}

.table-form {
  .table-form-item {
    padding: 10px 0;

    ::v-deep .el-form-item__content {
      .el-form-item__error {
        transform: translateY(-10px);
      }
    }

  }

}
</style>
